export default "__VITE_ASSET__mMSVPp27__"